import { useSuspenseQuery } from "@tanstack/react-query";

import { useEnableOrbac } from "featureFlags/hooks/useEnableOrbac";
import { systemEngineEnvironment } from "services/environment/systemEngine";
import { ReactQueryKeysGlobal } from "services/queryKeys";

import { authService } from "./index";
import { useClaims } from "./useClaims";

const ORGANIZATION_ADMIN = "ORGANIZATION_ADMIN";

const checkOrgAdminPrivileges = async (loginName: string) => {
  const sql = `select * from  org_db.information_schema.transitive_applicable_roles where LOWER(grantee) = LOWER('${loginName}') and role_name = 'org_admin' limit 1;`;
  const result = await systemEngineEnvironment.execute(sql);
  const [response] = result;
  return response.rows.length > 0;
};

export const useHasAdminRole = () => {
  const claims = useClaims();
  const enableOrbac = useEnableOrbac();
  const roles = claims?.global_roles || [];

  const { data: hasOrgAdminPrivileges = false } = useSuspenseQuery({
    queryKey: [ReactQueryKeysGlobal.orgAdminPrivileges, enableOrbac],
    queryFn: async () => {
      if (!enableOrbac) {
        return false;
      }
      try {
        const auth0user = await authService.auth0client.getUser();
        const loginName = auth0user?.email ?? "";
        return await checkOrgAdminPrivileges(loginName);
      } catch (e) {
        // If the query fails, we assume the user does not have admin privileges
        return false;
      }
    },
  });

  if (enableOrbac) {
    return hasOrgAdminPrivileges;
  }

  return roles.includes(ORGANIZATION_ADMIN);
};
